import Cookies from 'js-cookie'

const TokenKey = 'Token'
const LoginKey = 'LoginName'
// const UserInfo = 'UserInfo'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function GetTokenKey() {
  return TokenKey
}

export function getLoginName() {
  return Cookies.get(LoginKey)
}

export function setLoginName(loginName) {
  return Cookies.set(LoginKey, loginName)
}

export function removeLoginName() {
  return Cookies.remove(LoginKey)
}
export function GetLoginKey() {
  return LoginKey
}
export function setNextTimeRouter(router, min) {
  var now = new Date()
  // 设置时间 
  now.setMinutes(now.getMinutes() + min)
  //设置cookie
  return Cookies.set('routerKey', router, { expires: now })
}
export function getNextTimeRouter() {
  return Cookies.get('routerKey')
}
export function removeNextTimeRouter() {
  return Cookies.remove('routerKey')
}
// export function getUserInfo() {
//   // return JSON.parse(Cookies.get(UserInfo))
//   return JSON.parse(localStorage.getItem(UserInfo))
// }

// export function setUserInfo(userInfo) {
//   // return Cookies.set(UserInfo, userInfo)
//   localStorage.setItem(UserInfo, JSON.stringify(userInfo))
// }

// export function removeUserInfo() {
//   // return Cookies.removeItem(UserInfo)
//   return localStorage.removeItem(UserInfo)
// }

// export function GetUserInfoKey() {
//   return UserInfo
// }
